import { Toaster } from "@blueprintjs/core";
import React, { useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import FileList from "./FileList";
import FolderTree from "./FolderTree";
import PreviewSection from "./PreviewSection";
import Toast from "./Toast";
import Toolbar from "./Toolbar";
import { advancedModeState, apiKeyState, designListState, toastState } from "../../recoil/filemanager/atoms";
import { getDesignTree } from "../../recoil/filemanager/selectors";
import { baseUrl } from "../../constants";
import { H4 } from "@alternative/components";
import classNames from "classnames";
const FileManager = () => {
  const [designList, setDesignList] = useRecoilState(designListState);
  const key = useRecoilValue(apiKeyState);
  useEffect(() => {
    const setList = async () => {
      const list = await getDesignTree({ key });
      setDesignList({ ...designList, ...list });
    };
    setList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, setDesignList]);
  return designList.designTree ? (
    <FileManagerWithList />
  ) : (
    <div className="at-file-man-container at-loading">
      <H4>Loading...</H4>
    </div>
  );
};
const UploadStatusToast = (props) => {
  const { uploadStatusToast, onDismiss } = props;
  const { progress, files, canDismiss } = uploadStatusToast;
  return (
    <Toast
      message={
        <>
          <span>
            {progress === 100 ? "Uploaded" : "Uploading"} {files} Files
          </span>
          <strong>{progress}%</strong>
        </>
      }
      canDismiss={canDismiss}
      onDismiss={onDismiss}
    />
  );
};
const FILE_MAN_CONTAINER = "at-file-man-container";
const FileManagerWithList = () => {
  const advancedMode = useRecoilValue(advancedModeState);
  const [toastListState, setToastLisState] = useRecoilState(toastState);
  const { toasts, uploadStatusToast } = toastListState;
  const handleToastDismiss = (index) => {
    const clone = [...toasts];
    clone.splice(index, 1);
    setToastLisState({ ...toastListState, toasts: clone });
  };
  const handleBackToExplorug = () => {
    const openSelf = () => {
      const url =
        process.env.NODE_ENV === "development" ? "http://localhost:23456?forcelogin" : `${baseUrl}?forcelogin`;
      window.open(url, "_self");
    };
    if (window.opener) {
      try {
        let loc;
        if (window.opener.href.search("index.html") === -1) {
          loc = "/index.html?forcelogin";
        } else {
          loc = "?forcelogin";
        }
        window.opener.location.replace(`${window.opener.location.href}${loc}`);
        window.close();
      } catch (error) {
        openSelf();
      }
    } else {
      openSelf();
    }
  };
  return (
    <div className={classNames(FILE_MAN_CONTAINER, { [`${FILE_MAN_CONTAINER}--simple-mode`]: !advancedMode })}>
      <Toolbar />
      <div className="folder-tree">
        <FolderTree />
      </div>
      <div className="filelist-panel">
        <FileList />
      </div>
      <PreviewSection onBackToExplorug={handleBackToExplorug} />
      <Toaster position="bottom" maxToasts={5}>
        {uploadStatusToast && (
          <UploadStatusToast
            uploadStatusToast={uploadStatusToast}
            onDismiss={() => {
              setToastLisState({ ...toastListState, uploadStatusToast: null });
            }}
          />
        )}
        {toasts.map((toast, i) => (
          <Toast
            message={toast.message}
            canDismiss={toast.canDismiss}
            onDismiss={() => handleToastDismiss(i)}
            key={i}
          />
        ))}
      </Toaster>
      {/* <DuplicateEntryDialog />
      <UploadErrorDialog />
      <DeleteEntryDialog /> */}
    </div>
  );
};

export default FileManager;
